import React from "react";
import { Container, Typography, Box } from "@mui/material";
import CustomizedTabs from "../../../shared/components/navigations/tabs";
// import ScopeCertificateComponent from "./sc-tabs/scope-certificate-details";
// import FacilityDetailsComponent from "./sc-tabs/facility-details";
// import ProductManagementComponent from "./sc-tabs/facility-product-details";
// import CertifiedOrganizationDetails from "./sc-tabs/certified-organization-details/certified-organization-details";
import { useParams } from "react-router-dom";
import ShipmentsDetails from "../etc-tabs/shipments-details";
// import BuyerSellerDetails from "../etc-tabs/buyer-seller-details";
import TransactionDetails from "../etc-tabs/transaction-details";
import BuyerSellerDetails from "../etc-tabs/buyer-seller-details";
import CertifiedRawMaterialsStdDetails from "../etc-tabs/certified-raw-materials-std-details";
import EtcComponentsDetails from "../etc-tabs/etc-components-details";
import EtcProductDetails from "../etc-tabs/etc-product-details";
import InputEtcProductDetails from "../etc-tabs/input-etc-product-details";
import InputEtcComponentsDetails from "../etc-tabs/input-etc-components-details";
import DeclarationSubmitDetails from "../etc-tabs/declaration-submit-details";

const EtcForm = () => {
  const { formtype, etcId } = useParams<{ formtype: string; etcId: string }>();
  const baseUrl = formtype ?? "view-etc";
  const tabs = [
    {
      id: "transaction-details",
      label: "Transaction Details",
      component: <TransactionDetails />,
    },
    {
      id: "buyer-seller-details",
      label: "Buyer and Seller Details",
      component: <BuyerSellerDetails />,
    },
    {
      id: "shipments-details",
      label: "Shipments",
      component: <ShipmentsDetails />,
    },
    {
      id: "etc-product-details",
      label: "Certified Products",
      component: <EtcProductDetails />,
    },
    {
      id: "etc-components-details",
      label: "Certified Components",
      component: <EtcComponentsDetails />,
    },

    {
      id: "certified-raw-materials-std-details",
      label: "Certified Raw Materials and Declared Geographic Origin",
      component: <CertifiedRawMaterialsStdDetails />,
    },
    {
      id: "input-etc-product-details",
      label: "Certified Input References",
      component: <InputEtcProductDetails />,
    },
    {
      id: "input-etc-components-details",
      label: "Certified Input Components",
      component: <InputEtcComponentsDetails />,
    },
    
    {
      id: "declaration-submit-details",
      label: "Declarations",
      component: <DeclarationSubmitDetails />,
    },
  ];

  return (
    <>
      <Box sx={{ textAlign: "left" }}></Box>
      <Box sx={{ mt: "2px" }}>
        <CustomizedTabs tabs={tabs} baseUrl={baseUrl} system="etc" ID={etcId} />
      </Box>
    </>
  );
};

export default EtcForm;
